import React from 'react'
import CardSection from '../budha-fellowship-program/cardSection'
import AdminSignIn from '../authentication/login'

export default function DonateUsAdmin() {
    return (
        <>
            <CardSection section='03' sectionTitle='Every donation is the key to uplifting individuals,
communities, and generations.'  role='compassionate' note='Note: Changes made to this section will be reflected across all pages where this section is used. (eg. 
Partners & Supporters And Donate Us)' />
        </>
    )
}
